import React, {useEffect, useState} from 'react';
import transactionService from '../../../services/transactionService';
import TableComponent, {TableComponentProps} from '../../../components/molecules/Table/component';
import {transactionsTableColumns} from '../../../components/molecules/Table/columns';
import {useIsMobile} from "../../../utils/helpers";
import {mobileRenderers} from "../../../components/molecules/Table/tableMobileRenderers";

const TransactionListPage: React.FC = () => {
    const [data, setData] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const [filters, setFilters] = useState({
        transactionType: '',
        status: '',
        fromUsername: '',
        toUsername: '',
        sortColumn: 'createdAt' as 'amount' | 'createdAt',
        sortDirection: 'desc' as 'asc' | 'desc',
    });
    const isMobile = useIsMobile();

    useEffect(() => {
        (async () => {
            setLoading(true);
            try {
                const list = await transactionService.getTransactions(filters);
                setData(list);
            } finally {
                setLoading(false);
            }
        })();
    }, [filters]);

    const handleTableChange: TableComponentProps<any>['onChange'] = (
        _pagination: any,
        _tableFilters: any,
        sorter: any,
    ) => {
        const transactionType = _tableFilters.transactionType as string || '';
        const status = _tableFilters.status as string || '';
        const fromUsername = _tableFilters.from as string || '';
        const toUsername = _tableFilters.to as string || '';

        let sortColumn = filters.sortColumn;
        let sortDirection = filters.sortDirection;
        if (sorter && 'field' in sorter && sorter.order) {
            sortColumn = sorter.field as 'amount' | 'createdAt';
            sortDirection = sorter.order === 'ascend' ? 'asc' : 'desc';
        }

        setFilters({
            transactionType: transactionType !== '' ? transactionType[0] : '',
            status: status !== '' ? status[0] : '',
            fromUsername,
            toUsername,
            sortColumn,
            sortDirection,
        });
    };

    return (
        <div style={{position: 'relative', paddingTop: isMobile ? '40px' : '20px'}}>
            <TableComponent title={"Transactions"} columns={transactionsTableColumns} data={data} loading={loading}
                            onChange={handleTableChange} isMobile={isMobile} mobileVariant="transactions"
                            mobileRenderers={mobileRenderers}
            />
        </div>
    );
};

export default TransactionListPage;